import PropTypes from 'prop-types';
import { Modal } from '@bwoty-web/ui-kit';
import RoomType from '../../../../common/roomType';

const RoomTypePopup = ({
  isConceptHotel = false,
  accommodationSection,
  toggleRoomInfo,
  roomType = null,
  generalUspList = null,
  showPartInfoRoomList,
}) => {
  return (
    <Modal
      className="gw-room-type-popup--scroll-anchor"
      onClose={() => toggleRoomInfo()}
      overlaidCloseButton
      size="m"
    >
      <RoomType
        isConceptHotel={isConceptHotel}
        accommodationSection={accommodationSection}
        toggleRoomInfo={toggleRoomInfo}
        roomType={roomType}
        generalUspList={generalUspList}
        showPartInfoRoomList={showPartInfoRoomList}
        inPopup
      />
    </Modal>
  );
};

RoomTypePopup.propTypes = {
  isConceptHotel: PropTypes.bool,
  showPartInfoRoomList: PropTypes.bool.isRequired,
  accommodationSection: PropTypes.shape({}).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  generalUspList: PropTypes.shape({}),
  roomType: PropTypes.shape({ name: PropTypes.string }),
};

export default RoomTypePopup;
